import { createSlice } from '@reduxjs/toolkit';
import { CurrentContactType } from 'types/currentEvent';

// initial state
const initialState: CurrentContactType = { mainData: { id: '' }, contactHistories: [] };

// ==============================|| SLICE - ALGOLIA ||============================== //

const currentContact = createSlice({
  name: 'currentContact',
  initialState,
  reducers: {
    setCurrentContact(state, action) {
      state.mainData = action.payload;
    },
    setContactHistories(state, action) {
      state.contactHistories = action.payload;
    }
  }
});

export default currentContact.reducer;

export const { setCurrentContact, setContactHistories } = currentContact.actions;
